import { MINUTE_HEIGHT_PX } from 'constants/hour';
import { TIMELINE_PX_OFFSET } from 'constants/memory';
import { DateTime } from 'luxon';

interface EventPixelOptions {
  pixelsPerMinute: number | null | undefined;
  hasMinimumHeight?: boolean;
}

export function convertTimestampToPx(
  from: string | null,
  startHour: string,
  timelineOffsetY: number = TIMELINE_PX_OFFSET,
  options: EventPixelOptions = { pixelsPerMinute: MINUTE_HEIGHT_PX }
): number {
  if (!startHour) {
    return 100;
  }
  const timelineStartsAt = DateTime.fromISO(startHour);
  const eventFrom = DateTime.fromISO(from!);
  const minutes = eventFrom.diff(timelineStartsAt, 'minutes').minutes;
  const minutesToPixels = minutes * (options.pixelsPerMinute ?? MINUTE_HEIGHT_PX) + timelineOffsetY;

  if (options.hasMinimumHeight) {
    return Math.max(10, minutesToPixels);
  }

  return minutesToPixels;
}
